import config from '../config'

export const checkoutRedirect = (page: string) =>
  (window.location.href = `${config.checkoutOrigin}/${page}?referrer=checkout`)
